<template>
  <div>

    <!-- Missing overtime comment error -->
    <div class="text-center invalid-feedback d-block p-md-0 pt-2" v-if="IsOvertimeCommentMissing">
      {{$t(this.$getConst.pages.timesheet.overtime_comment_required)}}.
    </div>
    <!-- Max length overtime comment error -->
    <div class="text-center invalid-feedback d-block p-md-0 pt-2" v-if="IsOvertimeCommentTooLong">
      {{$t(this.$getConst.pages.timesheet.overtime_comment_too_long)}}.
    </div>

    <!-- Missing attachment error -->
    <div class="text-center invalid-feedback d-block p-md-0 pb-2" v-if="IsAttachmentMissing">
      {{$t(this.$getConst.pages.timesheet.attachment_required)}}.
    </div>

    <!-- work day error -->
    <div class="text-center invalid-feedback d-block p-md-0 pb-2" v-if="IsWorkDayTooLong">
      {{$t(this.$getConst.pages.alerts.invalid_hours_per_day)}}.
    </div>

    <!-- freelancer day error -->
    <div class="text-center invalid-feedback d-block p-md-0 pb-2" v-if="IsFreelancerWorkDayTooLong">
      {{$t(this.$getConst.pages.alerts.invalid_freelancer_hours_per_day)}}.
    </div>

    <!-- worker day error -->
    <div class="text-center invalid-feedback d-block p-md-0 pb-2" v-if="IsWorkerWorkDayTooLong">
      {{$t(this.$getConst.pages.alerts.invalid_total_std_hours)}}.
    </div>

    <!-- Worker buttons -->
    <AppConfirmButtons
      v-if="(isWorker() || isFreelancer()) && hasPermission($getConst.permissions.submitTimesheetForm)"
      :is-disabled="
        $v.timesheet.Notes.$invalid ||
        IsOvertimeCommentMissing ||
        IsOvertimeCommentTooLong ||
        IsAttachmentMissing ||
        isLoadingFirstButton ||
        IsFreelancerWorkDayTooLong ||
        IsWorkerWorkDayTooLong ||
        IsWorkDayTooLong ||
        timesheet.Status === $getConst.timesheetsStatus.submitted ||
        timesheet.Status === $getConst.timesheetsStatus.approved ||
        timesheet.Status === $getConst.timesheetsStatus.processed"
      :secondButtonDisabled="
        $v.timesheet.Notes.$invalid ||
        IsOvertimeCommentMissing ||
        IsOvertimeCommentTooLong ||
        IsAttachmentMissing ||
        isLoadingSecondButton ||
        IsFreelancerWorkDayTooLong ||
        IsWorkerWorkDayTooLong ||
        IsWorkDayTooLong ||
        timesheet.Status === $getConst.timesheetsStatus.submitted ||
        timesheet.Status === $getConst.timesheetsStatus.approved ||
        timesheet.Status === $getConst.timesheetsStatus.processed"
      class="mt-auto"
      second-button
      no-cancel
      :submit-text="$t($getConst.pages.button.submit)"
      @onSubmit="submit"
      :second-button-text="$t($getConst.pages.button.save)"
      @onSecondSubmit="save"
      :is-loading="isLoadingFirstButton"
      :isLoadingSecondButton="isLoadingSecondButton"
    />
    <!-- Rejection comment of Approver  L1 -->
    <template
      v-if="isApprover('L2')"
      >
      <template
        v-for="rejection in rejectionL1Reason"
      >
        <b-form-group
          :label="$t($getConst.pages.timesheet.approver_l1_comment + ' : '+rejection.name)"
          class="p-md-0 p-3"
          label-class="text-primary"
          label-for="rejectionReason-input"
        >
          <b-form-textarea
            id="rejectionReason-input"
            :value="rejection.RejectionReason"
            disabled="true"
            size="lg"
            :class="{ 'is-invalid': $v.rejectionReason.$error}"
          ></b-form-textarea>

          <AppFormFeedback :errors="$v.rejectionReason"/>
        </b-form-group>
      </template>

    </template>
    <!-- Rejection comment -->
    <b-form-group
      v-if="isApprover()"
      :label="$t($getConst.pages.timesheet.approver_comment)"
      class="p-md-0 p-3"
      label-class="text-primary"
      label-for="rejectionReason-input"
    >
      <b-form-textarea
        id="rejectionReason-input"
        v-model.trim="$v.rejectionReason.$model"
        :disabled="
          isLoadingSecondButton ||
          timesheet.Status === $getConst.timesheetsStatus.approved ||
          timesheet.Status === $getConst.timesheetsStatus.returned ||
          timesheet.Status === $getConst.timesheetsStatus.processed ||
          timesheet.Status === $getConst.timesheetsStatus.returnedByHays"
        size="lg"
        @input ="updateRejectionReason"
        :class="{ 'is-invalid': $v.rejectionReason.$error}"
      ></b-form-textarea>
      <AppFormFeedback :errors="$v.rejectionReason"/>
    </b-form-group>

    <!-- Approver buttons -->
    <AppConfirmButtons
      v-if="isApprover() && hasPermission($getConst.permissions.approveTimesheetForm)"
      :is-disabled="
        $v.rejectionReason.$invalid ||
        isLoadingFirstButton ||
        timesheet.Status === $getConst.timesheetsStatus.approved ||
        timesheet.Status === $getConst.timesheetsStatus.returned ||
        timesheet.Status === $getConst.timesheetsStatus.processed ||
        timesheet.Status === $getConst.timesheetsStatus.returnedByHays"
      :secondButtonDisabled="
        $v.rejectionReason.$invalid ||
        isLoadingSecondButton ||
        timesheet.Status === $getConst.timesheetsStatus.approved ||
        timesheet.Status === $getConst.timesheetsStatus.returned ||
        timesheet.Status === $getConst.timesheetsStatus.processed ||
        timesheet.Status === $getConst.timesheetsStatus.returnedByHays"
      class="mt-auto"
      :submit-text="$t($getConst.pages.button.approver)"
      @onSubmit="approve"
      first-button
      second-button
      :second-button-text="$t($getConst.pages.button.rejecter)"
      @onSecondSubmit="reject"
      :no-cancel="
        timesheet.Status === $getConst.timesheetsStatus.approved ||
        timesheet.Status === $getConst.timesheetsStatus.returned ||
        timesheet.Status === $getConst.timesheetsStatus.processed ||
        timesheet.Status === $getConst.timesheetsStatus.returnedByHays"
      @onCancel="cancel"
      :is-loading="isLoadingFirstButton"
      :isLoadingSecondButton="isLoadingSecondButton"
    />
  </div>
</template>

<script>
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import {
    approveTimesheet,
    rejectTimesheet,
    saveWorkerContratTimesheets,
    submitWorkerContratTimesheets
  } from "../../../api/timesheet.api";
  import {
    checkIfRequiredAttachmentMissing,
    checkIfOvertimeCommentMissing,
    checkIfOvertimeCommentTooLong, getSmartWorking
  } from "../../../shared/services/timesheets";
  import {maxLength, required} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";

  export default {
    name: "TimesheetConfirmButtons",
    components: {AppFormFeedback, AppConfirmButtons},
    computed: {
      IsOvertimeCommentMissing() {
        return checkIfOvertimeCommentMissing(this.timesheet);
      },
      IsAttachmentMissing() {
        return (checkIfRequiredAttachmentMissing(this.timesheet) && this.isWorker());
      },
      IsFreelancerWorkDayTooLong() {
        let ret = false
        if (this.isFreelancer()) {
          this.timesheet.Days.Days.forEach(el => {
            let totalHoursStdPerDay = parseFloat(el.absenceQty) + parseFloat(el.std)
            if (getSmartWorking(this.timesheet)) {
              totalHoursStdPerDay += parseFloat(el[getSmartWorking(this.timesheet)])
            }
            if (totalHoursStdPerDay > this.timesheetStd) {
              ret = true
            }
          })
        }
        return ret
      },
      IsWorkerWorkDayTooLong() {
        let ret = false
        if (this.isWorker() && this.isLimitingHoursOfWork) {
          this.timesheet.Days.Days
            .filter(day=>day.isHoliday==="No")
            .forEach(el => {
            let totalHoursStdPerDay = parseFloat(el.absenceQty) + parseFloat(el.std)
            if (getSmartWorking(this.timesheet)) {
              totalHoursStdPerDay += parseFloat(el[getSmartWorking(this.timesheet)])
            }
            if (totalHoursStdPerDay !== this.timesheetStd) {
              ret = true
            }
          })
        }
        return ret
      },
      IsWorkDayTooLong() {
        let ret = false
        this.timesheet.Days.Days.forEach(el => {
          let totalHoursPerDay = parseFloat(el.absenceQty) + parseFloat(el.std) + parseFloat(el.ot1) + parseFloat(el.ot2) + parseFloat(el.ot3)
          if (totalHoursPerDay > 24) {
            ret = true
          }
        })
        return ret
      },
      IsOvertimeCommentTooLong() {
        return checkIfOvertimeCommentTooLong(this.timesheet);
      }
    },
    props: {
      timesheet: null,
      timesheetStd: null,
    },
    data() {
      return {
        isLoadingFirstButton: false,
        isLoadingSecondButton: false,
        rejectionReason: null,
        rejectionL1Reason:[],
        isRejectingTimesheet: false,
        displayRejectionReason: false,
        isLimitingHoursOfWork: false
      }
    },
    validations() {
      let rejectionReasonValidation = {};
      if (this.isRejectingTimesheet && this.isApprover()) {
        rejectionReasonValidation = {required, maxLength: maxLength(100)};
      } else {
        rejectionReasonValidation = {maxLength: maxLength(100)};
      }

      return {
        rejectionReason: rejectionReasonValidation,
        timesheet: {Notes: {maxLength: maxLength(100)}},
      }
    },
    methods: {
      cancel() {
        this.isRejectingTimesheet = false;
        this.rejectionReason = null;
      },
      submit() {
        this.isLoadingFirstButton = true;
        submitWorkerContratTimesheets(this.timesheet).then(
          () => {
            this.setTimesheetsInStore(this.$store.state.auth.account);
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            this.$router.push({name: this.$getConst.routesNames.timesheets});
            this.isLoadingFirstButton = false;
          }, (error) => {
            this.handleWorkerResponse(error);
            this.isLoadingFirstButton = false;
          }
        );
      },
      save() {
        this.isLoadingSecondButton = true;
        saveWorkerContratTimesheets(this.timesheet).then(
          (response) => {
            if(response.data.SaveResponse.Error == null){
              this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
              this.$router.push({name: this.$getConst.routesNames.timesheets});
            }
            else{
              this.$snotify.error(response.data.SaveResponse.Error, this.$t(this.$getConst.pages.alerts.error));
            }
            this.isLoadingSecondButton = false;
          }, (error) => {
            this.isLoadingSecondButton = false;
            this.handleWorkerResponse(error);
          }
        );
      },
      reject() {
        this.isRejectingTimesheet = true;
        this.$v.rejectionReason.$touch();
        if(!this.$v.rejectionReason.$invalid) {
          this.isLoadingSecondButton = true;
          rejectTimesheet(this.timesheet).then(
            (response) => {
              if (response.data.RejectResponse.Error == null) {
                this.setTimesheetsInStore(this.$store.state.auth.account);
                this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
                this.$router.push({name: this.$getConst.routesNames.timesheets});
              }
              else {
                this.$snotify.error(response.data.RejectResponse.Error, this.$t(this.$getConst.pages.alerts.error));
              }
              this.isLoadingSecondButton = false;
            }, (error) => {
              const errorData = error.response.data;
              if (errorData.code === 422) {
                if (errorData.error.Approvers.find(err => err.includes("permission"))) {
                  this.$snotify.error(this.$t(this.$getConst.pages.alerts.dont_have_permission_msg));
                  this.$router.push({name: this.$getConst.routesNames.timesheets});
                } else if (errorData.error.Approvers.find(err => err.includes("rejection"))) {
                  this.$snotify.error(this.$t(this.$getConst.pages.timesheet.rejection_reason_required));
                }
              } else {
                this.handleApiError(error);
              }
              this.isLoadingSecondButton = false;
            }
          );
        }
      },
      approve() {
        this.isRejectingTimesheet = false;
        this.isLoadingFirstButton = true;
        approveTimesheet(this.timesheet).then(
          (response) => {
            if(response.data.ApproveResponse.Error == null){
              this.setTimesheetsInStore(this.$store.state.auth.account);
              this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
              this.$router.push({name: this.$getConst.routesNames.timesheets});
            }
            else{
              this.$snotify.error(response.data.ApproveResponse.Error, this.$t(this.$getConst.pages.alerts.error));
            }
            this.isLoadingFirstButton = false;
          }, (error) => {
            this.isLoadingFirstButton = false;
            this.handleApiError(error)
          }
        );
      },
      updateRejectionReason(reason){
        for (let approver of this.timesheet.Approvers) {
          if(approver.id === this.$store.getters["auth/navId"]){
            approver.RejectionReason = reason;
          }
        }
      },
      isTimesheetHasRejectionReason() {
        this.displayRejectionReason = false;
        if (this.isWorker()) {
          return false;
        }
        for (let approver of this.timesheet.Approvers) {
          if(approver.RejectionReason && approver.RejectionReason !== "" ){
            if(approver.id==this.$store.getters["auth/navId"]){
              this.displayRejectionReason = true;
              this.rejectionReason = approver.RejectionReason;
            }else if(approver.level=="L1"){
              this.rejectionL1Reason.push(approver);
            }

          }
        }
      },
      handleWorkerResponse(error) {
        const errorData = error.response.data;
        if (errorData.code === 422) {
           if (errorData.error.Attachments && errorData.error.Attachments.find(err => err.includes("required"))) {
            this.$snotify.error(this.$t(this.$getConst.pages.timesheet.attachment_required));
          }
          if (errorData.error.Days && errorData.error.Days.find(err => err.includes("required"))) {
            this.$snotify.error(this.$t(this.$getConst.pages.timesheet.overtime_comment_required));
          }
          if (errorData.error.Days && errorData.error.Days.find(err => err.includes("maximum"))) {
            this.$snotify.error(this.$t(this.$getConst.pages.timesheet.overtime_comment_too_long));
          }
          if (errorData.error.Notes) {
            this.$snotify.error(this.$t(this.$getConst.pages.form.maxLength_field_error) + " 100");
          }
        } else {
          this.handleApiError(error);
        }
      }
    },
    created() {
      if (this.$route.query.q === "reject") {
        this.isRejectingTimesheet = true;
        this.$v.rejectionReason.$touch();
      }
      this.isTimesheetHasRejectionReason();
    },
    mounted() {
      if (this.$store.getters['auth/scopeDefault'].is_limiting_hours_of_work === true) {
        this.isLimitingHoursOfWork = true;
      }
    }
  }
</script>

<style scoped>

</style>
